import Button from "~/components/ui/Button"
import Icon, { type AvailableIcons } from "~/components/ui/Icon"
import { invoke } from "~/runtime"
import { useSignal } from "~/sdk/signal"
import type { JSX } from "react"

const INPUT_TYPE_MAPPINGS = {
    Nome: 'text',
    Email: 'email',
}

const INPUT_NAME_MAPPINGS = {
    Nome: 'name',
    Email: 'email',
}

type InputType = keyof typeof INPUT_TYPE_MAPPINGS

/**
 * @titleBy name
 */
interface Input {
    placeholder: string
    /**
     * @title Obrigatório
     * @default false
     */
    required: boolean
    /**
     * @title Tipo
     */
    // type: InputType; <- aparentemente o CMS não aceita tipagem dessa maneira
    type: 'Nome' | 'Email'
}

interface CTA {
    /**
     * @title Texto CTA
     * @description Texto do botão de "enviar"
     */
    text: string
}

export interface Props {
    /**
     * @title Ícone
     */
    icon: AvailableIcons
    /**
     * @title Título
     */
    title: string
    /**
     * @title Descrição
     * @format html
     */
    description: string
    inputs: Input[]
    cta: CTA
    /**
     * @title Texto de finalização
     * @description Texto que aparecerá após o usuário assinar a newsletter
     * @format html
     */
    feedback: string
}

// Tudo pronto! Agora é só aproveitar o seu Cupom: NEWS5 - Pedido mínimo de R$ 150.

export default function Newsletter({ icon, title, description, inputs, cta, feedback }: Props) {
    const loading = useSignal(false)
    const createdAccount = useSignal(false)

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        try {
            loading.value = true

            const name = (e.currentTarget.elements.namedItem('name') as RadioNodeList)?.value
            const email = (e.currentTarget.elements.namedItem('email') as RadioNodeList)?.value

            await invoke.vtex.actions.masterdata.createDocument({
                acronym: 'NL',
                data: { nome: name, email },
            })
            createdAccount.value = true
        } finally {
            loading.value = false
        }
    }

    return (
        <div className='flex flex-col items-center justify-center w-full gap-2 pt-2 text-center lg:hidden pb-9'>
            <Icon id={icon} size={24} />
            <h2 className='font-bold text-salmon'>{title}</h2>
            <div dangerouslySetInnerHTML={{ __html: description }} />
            {createdAccount.value
                ? (
                    <div
                        className='p-1 text-black bg-white border-4 border-salmon'
                        dangerouslySetInnerHTML={{ __html: feedback }}
                    />
                )
                : (
                    <form
                        onSubmit={handleSubmit}
                        autoComplete='on'
                        className='flex justify-center w-full gap-2'
                    >
                        {inputs.map((props) => (
                            <input
                                {...props}
                                disabled={loading.value}
                                name={INPUT_NAME_MAPPINGS[props.type as InputType] ?? 'name'}
                                type={INPUT_TYPE_MAPPINGS[props.type as InputType] ?? 'text'}
                                className='min-w-0 px-2 text-white bg-transparent border-0 border-b-2 border-white rounded-none input input-ghost placeholder:text-neutral-500 focus:text-white focus-within:text-white'
                            />
                        ))}
                        <Button
                            disabled={loading.value}
                            loading={loading.value}
                            className='min-w-0 min-h-0 font-bold text-white border-none bg-salmon focus:outline-none hover:bg-salmon-600'
                            type='submit'
                        >
                            {cta.text}
                        </Button>
                    </form>
                )}
        </div>
    )
}
